import { Api } from "@/plugins/api"

export const contactExistByEmail = (email) => {
  return Api.get("/contacts/exists-by-email?email=" + email)
}

export const isFormulaireDemandeAutorisationSpecialeCoche = (id) => {
  return Api.get("/contacts/" + id + "/formulaire-demande-autorisation-speciale-coche")
}

export const findByNumeroPermis = (numeroPermis) => {
  return Api.get("/contacts/find-by-numero-permis?numeroPermis=" + numeroPermis)
}